<template lang="pug">
  div#advisoryMap
    v-container#container-map(fluid)
      v-dialog(v-model="dialog" max-width="500")
        v-card
          a.download-postal(:href="postalImage" target="_blank")
            v-icon cloud_download
          v-btn.close-dialog(icon @click.native="dialog = false")
            v-icon close
          v-card-media.headline(:src="postalImage" height="100%")

      v-layout.text-xs-center(row justify-center align-center)
        v-flex.text-xs-center(xs6 sm6 md3)
          p.resultado.mt-3.mb-0.pa-2.text-xs-center 
            span.uppercase.bold.small Resultado&nbsp;
            span.accent-text.larger.bolder {{ reports.length }}&nbsp;
            span.larger.bolder Asesorías

      v-layout(row wrap justify-center align-content-center)
        v-flex(xs12 sm9 xs9)
          #advisoryMapId
        v-flex.pl-1(xs12 sm9 md3)
          States

      v-layout(row wrap)
        v-flex(xs12 sm12 md4)
          v-btn.btn-black.ml-2.mb-3(outline large color="black" @click="downloadData()") Descargar Datos

</template>

<script>
import L from "leaflet";
import States from "@/components/States";
import Card from "@/components/Card";
import * as d3 from "d3";

export default {
  name: "Map",

  data() {
    return {
      mymap: undefined,
      markers: [],
      markerLayer: undefined,
      dialog: false,
      postalImage: ""
    };
  },
  components: {
    States,
    Card
  },
  computed: {
    reports: {
      get() {
        return this.$store.state.filteredReports;
      }
    }
  },
  watch: {
    "$store.state.selection": function() {
      if (this.$store.state.selection)
        this.markers
          .find(marker => {
            return marker._leaflet_id == this.$store.state.selection;
          })
          .fire("click");
      else this.mymap.closePopup();
    },
    "$store.state.filteredReports": function() {
      this.drawMarkers();
    }
  },
  methods: {
    drawMap() {
      this.mymap = L.map("advisoryMapId").setView([10, 5], 2);
      this.mymap.scrollWheelZoom.disable();

      let accessToken =
        "pk.eyJ1Ijoiam9yYW5kcmFkZWZpZyIsImEiOiJjamV0bm9vczAzMTc3MnlvMG4wMTBlaXY0In0.6Te0HBRHyNH0TAVIQNT89w";

      L.tileLayer(
        `https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=${accessToken}`,
        {
          attribution:
            'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,
          tileSize: 512,
          zoomOffset: -1,
          id: "mapbox/streets-v11"
        }
      ).addTo(this.mymap);

      this.mymap.on("popupclose", () => {
        this.$store.commit("setSelection", undefined);
      });

      this.drawMarkers();
    },
    drawMarkers() {
      this.markers = [];
      if (this.markerLayer) {
        this.markerLayer.clearLayers();
      }

      this.reports.forEach(report => {
        const svg = `
        <?xml version="1.0" encoding="UTF-8"?>
        <svg width="30px" height="37px" viewBox="0 0 30 37" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <!-- Generator: Sketch 50.2 (55047) - http://www.bohemiancoding.com/sketch -->
            <title>Shape</title>
            <desc>Created with Sketch.</desc>
            <defs>
                <path d="M738,1112 C731.918571,1112 727,1116.5385 727,1122.15 C727,1129.7625 738,1141 738,1141 C738,1141 749,1129.7625 749,1122.15 C749,1116.5385 744.081429,1112 738,1112 L738,1112 Z M734,1122 C734,1119.792 735.7248,1118 737.85,1118 C739.9752,1118 741.7,1119.792 741.7,1122 C741.7,1124.208 739.9752,1126 737.85,1126 C735.7248,1126 734,1124.208 734,1122 Z" id="path-1"></path>
                <filter x="-31.8%" y="-17.2%" width="163.6%" height="148.3%" filterUnits="objectBoundingBox" id="filter-2">
                    <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.258520154 0" type="matrix" in="shadowBlurOuter1"></feColorMatrix>
                </filter>
            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g id="RRM_back02" transform="translate(-723.000000, -1110.000000)">
                    <g id="Shape">
                        <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1"></use>
                        <use fill="#c90287" fill-rule="evenodd" xlink:href="#path-1"></use>
                    </g>
                </g>
            </g>
        </svg>
        `;
        const advisoryIcon = L.divIcon({
          className: "pin",
          html: svg,
          iconAnchor: [16, 34],
          popupAnchor: [0, -35]
        });

        if (report.lat && report.lng) {

          let marker = L.marker(
            [parseFloat(report["lat"]), parseFloat(report["lng"])],
            { icon: advisoryIcon }
          );

          const tooltip = this.createTooltip(report);
          marker.bindPopup(tooltip);

          marker._leaflet_id = report.folio;
          marker.on("click", e => {
            const folio = e.sourceTarget._leaflet_id;
            this.$store.commit("setSelection", folio);
            marker.openPopup();
          });

          this.markers.push(marker);
        }
      });

      this.markerLayer = L.layerGroup(this.markers).addTo(this.mymap);
    },
    createTooltip(report) {
      const mapTooltip = d3.create("div");

      mapTooltip
        .append("p")
        .attr("class", "tooltip-text")
        .append("text")
        .text(
          report.synthesis.state ? report.synthesis.state : "No disponible, "
        )
        .append("span")
        .attr("class", "green-text")
        .text(report.year);

      mapTooltip
        .append("button")
        .attr("class", "btn-popup")
        .text("Ver Postal")
        .on("click", () => {
          this.openPopup(report.postal.url);
        });

      return mapTooltip.node();
    },
    openPopup(postal) {
      this.dialog = true;
      this.postalImage = postal;
    },
    downloadData() {
      let lineArray = [
        "data:text/csv;charset=utf-8,Folio,Fecha de atención, Estado, Municipio,Asunto de la asesoría,Intervención,Canalización,Edad,Sexo,Ocupación,Estado civil"
      ];
      this.reports.forEach(infoArray => {
        let line = "";
        line += infoArray.attention.folio + ",";
        line += infoArray.attention.attentionDate + ",";
        line += infoArray.synthesis.state + ",";
        line += infoArray.synthesis.municipality + ",";
        line += this.showSelections(infoArray.synthesis.matter) + ",";
        line += this.showSelections(infoArray.synthesis.intervention) + ",";
        line += this.showSelections(infoArray.synthesis.referred) + ",";
        line += infoArray.petitioner.age + ",";
        line += infoArray.petitioner.sex + ",";
        line += infoArray.petitioner.occupation + ",";
        line += infoArray.petitioner.civilStatus + ",";
        lineArray.push(line);
      });

      let csvContent = encodeURI(lineArray.join("\n"));
      var link = document.createElement("a");
      link.setAttribute("href", csvContent);
      link.setAttribute("download", "datos-asesorias.csv");
      document.body.appendChild(link);
      link.click();
    },
    showSelections(obj) {
      let selected = [];
      obj.forEach(val => {
        if (val.isSelected) {
          selected.push(val.text);
        }
      });
      return selected.join(", ");
    }
  },
  mounted() {
    this.drawMap();
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800");

#advisoryMap {
  background-color: #f7f7f7;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 1rem;
}
#advisoryMapId {
  height: 600px;
  width: 98%;
  z-index: 0;
}

#container-map {
  padding: 0px 10% 0px 10%;
}

#map .btn-black {
  border-radius: 10px;
  font-weight: 600;
  border: 2px solid black !important;
  font-size: 12px;
  margin-top: 8%;
}

.note-line {
  margin-top: 20px;
  margin-bottom: 10px;
  width: 18%;
  border: 1px solid #be3117;
}

.note {
  font-size: 11px;
}

.italic {
  font-style: italic;
}

.busqueda {
  padding-right: 2%;
  font-size: 16px;
  margin-top: 10%;
}
#advisoryMap .resultado {
  background-color: black;
  color: #fff;
  display: block;
}

.leaflet-popup-content-wrapper {
  border-radius: 0px;
  width: 178px;
  border: solid 2px black;
  background-color: #f8f8f8;
}
.leaflet-popup-tip {
  background-color: black;
}
.leaflet-popup-content {
  text-align: center;
}
.btn-popup {
  background-color: black;
  color: #ffffff;
  padding: 2px 20px 2px 20px;
  font-weight: 500;
  cursor: pointer;
}

.btn-popup:hover {
  background-color: #2f701d !important;
  color: #ffffff;
}

.tooltip-text {
  font-weight: 600;
}

.panel {
  align-self: center;
}

.close-dialog {
  position: absolute;
  display: block;
  z-index: 4;
  left: 440px;
}

.close-dialog:hover {
  position: absolute;
  display: block;
  z-index: 4;
  left: 440px;
}

.close-dialog:before {
  background-color: white !important;
}

.download-postal {
  position: absolute;
  display: block;
  z-index: 4;
  left: 417px;
  top: 9px;
}
</style>
